import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { ScrollService } from '../../core/scroll.service';
import { LangService } from '../../core/lang.service';
import { Subscription } from 'rxjs';
import { ChecklistStep, ChecklistStepRoute } from '../pnel-cts-checklist/model/checklist-steps';
import * as moment from 'moment';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { MyTestSessionsSetupService } from '../my-test-sessions-setup.service';



@Component({
  selector: 'view-cts-accommodations',
  templateUrl: './view-cts-accommodations.component.html',
  styleUrls: ['./view-cts-accommodations.component.scss']
})
export class ViewCtsAccommodationsComponent implements OnInit, OnDestroy {

  public breadcrumb = [];
  public setupId:string;

  private routeSub:Subscription;
  private mySetupSub:Subscription;

  constructor(
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private scrollService:ScrollService,
    private lang:LangService,
    private mySetup: MyTestSessionsSetupService
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    this.scrollService.scrollToTop();
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.setupId = routeParams['setupId'];
      this.breadcrumb = this.mySetup.generateBreadcrumbs(this.setupId, 'title_accom');
    });
    this.initRouteView();
  }

  ngOnDestroy(){
    if (this.routeSub) { this.routeSub.unsubscribe(); }
    if (this.mySetupSub) { this.mySetupSub.unsubscribe(); }
  }

  initRouteView(){
    let isInited = false;
    this.mySetupSub = this.mySetup.sub().subscribe(setupInfo => {
      if (setupInfo && !isInited){
        isInited = true;
        const setupId = parseInt(this.setupId);
        this.mySetup.checkoffAccommCoord(setupId);
      }
    })
  }

  isReadyToContinue(){
    return this.mySetup.getChecklistStepState(ChecklistStepRoute.Accommodations)
  }
  
  getCurrentStepId(){
    return ChecklistStep.Accommodations
  }

  gotoNextRoute(){
    const nextRouteSuffix = ChecklistStepRoute.RestrictedSessions;
    let breadcrumb = this.breadcrumbsService.TESTADMIN_CREATE_TEST_SESSION(this.setupId, nextRouteSuffix);
    this.router.navigate([ breadcrumb.route ]);
  }

}
